<template>
  <div class="form-account callback_status text-center">
    <template v-if="!error">
      <h2>Fetching Tokenized Credit Card</h2>
      <spinner></spinner>
    </template>
    <template v-else>
      <h2>Error fetching Tokenization</h2>
      <div v-if="error" class="alert alert-danger" role="alert">
        <span v-html="error"></span>
      </div>
      <router-link to="/"><button class="btn btn-primary">Sign in</button></router-link>
    </template>
  </div>
</template>

<script>
    import { mutations } from '@/store.js'
    import Spinner from "../components/Spinner";

    export default {
        name: "PeachPaymentsCallback",
        components: {Spinner},
        data: function() {
            return {
                companyReference: null,
                registrationId: null,
                error: null
            }
        },
        computed: {
        },
        methods: {
            storeTokenization: function () {
                this.$http.get('/guest-management/v1/companies/' + this.companyReference + '/billing/store-tokenization?registrationId=' + this.registrationId
                ).then(response => {
                    console.log(response);
                    if (response.data.reference) {
                        console.log("Authenticated after Tokenization")
                        mutations.setAuthenticated(true)
                        const user = response.data
                        mutations.setHost(user)
                        console.log(user);
                        mutations.setCurrentEstablishmentReference(user.establishments[0].reference)
                        this.$root.$emit('signed-in', true)
                        this.$router.push({name: 'Account'})
                    }
                }).catch(error => {
                    if (error.response && error.response.data.message) {
                        this.error = error.response.data.message + ".\n Please sign in and try again.";
                    } else {
                        this.error = "There was a problem loading the tokenized credit card.<br> Please sign in and try again.";
                    }
                });
            },
        },
        mounted() {
            this.companyReference = this.$route.query.companyReference;
            this.registrationId = this.$route.query.id;
            if (this.companyReference && this.registrationId) {
                this.storeTokenization();
            }
        }
    }
</script>

<style lang="scss" scoped>
  @import "../styles/pages/peach_payments_callback";
</style>